import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TreeviewConfig, TreeviewItem } from 'ngx-treeview';
import { PurchaseOrder } from '../../../../models/PurchaseOrder.model';

@Component({
    selector: 'app-purchase-order-list-detail',
    templateUrl: 'purchase-order-list-detail.component.html'
})

export class PurchaseOrderListDetailComponent implements OnInit {

    @Input() purchaseOrder: PurchaseOrder;

    purchaseItems = []
    config = TreeviewConfig.create({
        hasAllCheckBox: false,
        hasFilter: false,
        hasCollapseExpand: false,
        decoupleChildFromParent: false,
        maxHeight: 500
    });

    constructor() { }

    ngOnInit() {
        const items = new TreeviewItem({
            text: 'Itens',
            value: null,
            collapsed: true,
            children: [...(this.purchaseOrder.items).map((it: any) => {
                return {
                    text: '-',
                    value: it,
                }
            })]
        });

        this.purchaseItems = [items] as any;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/purchase-order/components/purchase-order-list-detail/purchase-order-list-detail.component.ts